import { useId, useState } from "react";
import { Box, IconButton, FormLabel } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { styled } from "@mui/styles";
const Uploader = styled(Box)({
  width: "100%",
  padding: "1rem",
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 2,
});
type Props = {
  title?: string;
  required?: boolean;
  defaultValue?: string;
  onChange?: (file: File | null) => void;
};
const ImageUploader = ({
  title = "",
  required = false,
  defaultValue,
  onChange,
}: Props) => {
  const [selectedImage, setSelectedImage] = useState<string | undefined>(
    defaultValue
  );

  console.log(selectedImage);

  const id = useId();
  const handleImageRemove = () => {
    setSelectedImage(undefined);
    if (onChange) onChange(null);
  };

  return (
    <Uploader bgcolor={"primary.main"} mb={3}>
      <FormLabel
        required={required}
        sx={{
          width: "100%",
          textAlign: "right",
          color: "divider",
          fontSize: "1.2rem",
          fontFamily: "'YekanBold !important'",
          "& .MuiFormLabel-asterisk": { color: "red" },
        }}
      >
        {title}
      </FormLabel>
      <label htmlFor={`image-upload-${id}`}>
        <input
          id={`image-upload-${id}`}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => {
            if (e.target.files?.length) {
              setSelectedImage(URL.createObjectURL(e.target.files[0]));
              if (onChange) onChange(e.target.files[0]);
            }
          }}
        />
        {!selectedImage && (
          <img
            alt="upload"
            src={require("../../assets/images/uploadimage.png")}
            style={{
              width: "9rem",
              minWidth: "8rem",
              maxWidth: "9rem",
              cursor: "pointer",
            }}
          />
        )}
      </label>
      {selectedImage && (
        <Box position="relative">
          <IconButton
            sx={{
              position: "absolute",
              top: "-1.5rem",
              right: "-1.5rem",
            }}
            size="small"
          >
            <RemoveCircleIcon
              sx={{ color: "red", fontSize: "2rem" }}
              onClick={handleImageRemove}
            />
          </IconButton>
          <img
            src={selectedImage}
            alt="Uploaded"
            style={{ maxWidth: "100px", maxHeight: "100px" }}
          />
        </Box>
      )}
    </Uploader>
  );
};

export default ImageUploader;
